import { axiosInstanceFast } from "@services/api/axiosInstance";

const API_PREFIX = "/mesh-plugin";

/// Get condition operators for IF ELSE node
export const getConditions = async () => {
  const response = await axiosInstanceFast.get(`${API_PREFIX}/get-operators`);
  return response.data;
};

/// Execute mesh workflow
export const executeWorkflow = async (workflowPayload: any) => {
  const response = await axiosInstanceFast.post(
    `${API_PREFIX}/execute/workflow`,
    workflowPayload,
    {
      headers: {
        "Content-Type": "application/json",
      },
      timeout: 300000, // 5 minutes timeout
    },
  );
  return response.data;
};

/// Save mesh workflow
export const saveMeshWorkflow = async (workflowData: any) => {
  const response = await axiosInstanceFast.post(
    `${API_PREFIX}/save/workflow`,
    workflowData,
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
  return response.data;
};

/// Get mesh workflow by ID
export const getMeshWorkflow = async (workflowId: string) => {
  const response = await axiosInstanceFast.get(
    `${API_PREFIX}/get/workflow/${workflowId}`,
  );
  return response.data;
};

/// Get mesh workflow by ID
export const deleteMeshWorkflow = async (workflowId: string) => {
  const response = await axiosInstanceFast.delete(
    `${API_PREFIX}/delete/workflow/${workflowId}`,
  );
  return response.data;
};

// Get all workflows for a plugin
export const getAllWorkflows = async (pluginId: string) => {
  const response = await axiosInstanceFast.get(`${API_PREFIX}/workflows`, {
    params: {
      plugin_id: pluginId,
    },
  });

  // If the response indicates no data with status 0, return empty array instead of throwing
  if (
    response.data?.status === 0 &&
    response.data?.message === "No data found"
  ) {
    return { data: [], status: 1 };
  }

  return response.data;
};

// Get workflow by ID for a plugin
export const getWorkflowById = async (workflowId: string, pluginId: string) => {
  const response = await axiosInstanceFast.get(
    `${API_PREFIX}/workflows/${workflowId}`,
    {
      params: {
        plugin_id: pluginId,
      },
    },
  );
  return response.data;
};

// Save or update workflow for a plugin
export const saveWorkflows = async (
  payload: {
    workflowData: any[];
    is_edit: boolean;
  },
  pluginId: string,
) => {
  const response = await axiosInstanceFast.post(
    `${API_PREFIX}/workflows`,
    payload,
    {
      params: {
        plugin_id: pluginId,
      },
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  // Check if the response indicates an error even with 200 status
  if (response.data?.status === 0 && response.data?.message) {
    throw new Error(response.data.message);
  }

  return response.data;
};

// Delete workflow by ID for a plugin
export const deleteWorkflow = async (workflowId: string, pluginId: string) => {
  const response = await axiosInstanceFast.delete(
    `${API_PREFIX}/workflows/${workflowId}`,
    {
      params: {
        plugin_id: pluginId,
      },
    },
  );
  return response.data;
};

// Get categories and operations for EditFields node
export const getFieldCategories = async () => {
  const response = await axiosInstanceFast.get(`${API_PREFIX}/get-categories`);
  return response.data;
};

// Get available functions for Function node
export const getFunctions = async () => {
  const response = await axiosInstanceFast.get(`${API_PREFIX}/get-functions`);
  return response.data;
};

// Fetch system settings including version from Redis
export const fetchSystemSettings = async () => {
  const response = await axiosInstanceFast.get(
    "/system/settings/basic-settings",
  );
  return response.data;
};
